import React, { useTransition } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const FormButtons = ({
  className = "",
  isDraftBtn = false,
  isCancelBtn = true,
  isLoading = false,
  addBtnText = "Add New",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={`g_end gap-3 ${className}`}>
      {isDraftBtn && (
        <button
          id="draftBtn"
          className="draft_btn"
          type="submit"
          disabled={isLoading}
        >
          {t("Draft")}
        </button>
      )}
      {isCancelBtn && (
        <button
          className="cancel_btn"
          type="button"
          onClick={() => navigate(-1)}
        >
          {t("Cancel")}
        </button>
      )}
      <button
        id="submitBtn"
        className="main_btn"
        type="submit"
        disabled={isLoading}
      >
        {addBtnText}
      </button>
    </div>
  );
};

export default FormButtons;
